import { render, staticRenderFns } from "./RetoureV2.vue?vue&type=template&id=9181e41c&scoped=true"
import script from "./RetoureV2.vue?vue&type=script&lang=js"
export * from "./RetoureV2.vue?vue&type=script&lang=js"
import style0 from "./RetoureV2.vue?vue&type=style&index=0&id=9181e41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9181e41c",
  null
  
)

export default component.exports